export enum DisplayTypes {
  ARTICLE_MEDIUM,
  MOBILE_APP,
}
